// A note's links are auto-detected from its body text, not typed separately — one
// pattern shared by extraction (what gets stored) and rendering (what gets linkified).
const URL_PATTERN = /https?:\/\/[^\s<>"']+/g;
export const findUrls = (text) => {
    const out = [];
    for (const m of text.matchAll(URL_PATTERN)) {
        const start = m.index ?? 0;
        // Strip trailing punctuation commonly typed right after a URL (sentence-ending
        // periods, closing brackets/quotes) so it doesn't become part of the link.
        const url = m[0].replace(/[.,;:!?)\]'"]+$/, "");
        out.push({ url, start, end: start + url.length });
    }
    return out;
};
export const extractUrls = (text) => Array.from(new Set(findUrls(text).map((m) => m.url)));
//# sourceMappingURL=note.js.map